import { useNextRouter } from '@/data/Content/_NextRouter';
import { useEffect } from 'react';

const pendingKeys = new Set<string>();

export const useRemoveQueryParams = (keys: readonly string[]) => {
	const router = useNextRouter();

	useEffect(() => {
		if (!globalThis.window || keys.length === 0) {
			return;
		}

		const removeKeys = () => {
			const isFirstPending = pendingKeys.size === 0;
			keys.forEach((key) => pendingKeys.add(key));

			if (!isFirstPending) {
				return;
			}

			setTimeout(() => {
				const url = new URL(globalThis.window.location.href);
				const presentKeys = [...pendingKeys].filter((key) => url.searchParams.has(key));
				pendingKeys.clear();

				if (presentKeys.length === 0) {
					return;
				}

				presentKeys.forEach((key) => url.searchParams.delete(key));

				router.replace(`${url.pathname}${url.search}${url.hash}`, undefined, { shallow: true });
			});
		};

		removeKeys();
		router.events.on('routeChangeComplete', removeKeys);
		return () => router.events.off('routeChangeComplete', removeKeys);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
};
